import React, { Component } from "react";
import axios from 'axios';
import _ from 'lodash';
import AutoSuggester from './autoSuggester';
import { connect } from "react-redux";
import * as searchActions from "../redux/actions/searchActions";
import { bindActionCreators } from "redux";
import SearchItemDetails from "./searchItemDetails";
import getAllHighlights from "./getAllHighlights";
import getNavigationDetails from "./getNavigationDetails";

class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            //searchLabel: '',
            searchResults: [],
            showSearchModal: false,
            setActiveButtonSearch: true,
            isVisibleNoResult: false,
            isLoading: false,
            value: ''
        }
        this.wrapperRef = React.createRef();
        this.escFunction = this.escFunction.bind(this);
        //this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleSearchText = _.debounce(this.onSearchText, 10);
        this.onSearch = this.onSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        //document.addEventListener("mousedown", this.handleClickOutside);
        document.addEventListener("keydown", this.escFunction, false);
        let inputRemove = document.getElementById("removed-search-input");
        if (inputRemove != null) {
            inputRemove.remove();
        }
        let inputRemoveMobile = document.getElementById("removed-search-input-mobile");
        if (inputRemoveMobile != null) {
            inputRemoveMobile.remove();
        }
        window.onpopstate = this.onBackOrForwardButtonEvent;
    }

    onBackOrForwardButtonEvent = (e) => {
        e.preventDefault();
        let locationHref = window.location.href;
        if (locationHref.includes('search/?search=')) {
            window.location.reload();
        }
   };

    componentDidUpdate() {
        window.onpopstate = e => {
            let locationHref = window.location.href;
            if (locationHref.includes('search/?search=')) {
                let search = window.location.search;
                let params = new URLSearchParams(search);
                let query = params.get('search');
                this.props.actions.setSearchLabel(query);
                this.onSearchNoModal(query);
            }
            else {
            window.location.reload();
            //    e.preventDefault();
            }
        }
        
    }


    componentWillUnmount() {
        //document.removeEventListener("mousedown", this.handleClickOutside);
        document.removeEventListener("keydown", this.escFunction, false);
        window.removeEventListener('onpopstate', this.onBackOrForwardButtonEvent, false)
    };

    //handleClickOutside(event) {
    //    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
    //        this.setState({
    //            showSearchModal: false
    //        });
    //    }
    //}

    escFunction(event) {
        if (event.keyCode === 27) {
            this.setState({
                showSearchModal: false
            });
        }
    }

    handleChange = (query, method) => {
        this.setState({
            showSearchModal: false, 
            setActiveButtonSearch: true,
            isVisibleNoResult: false
        }, function () {
            if (method === "click" || method === "enter") {
                this.onSearchNoModal();
            }
        });
        this.props.actions.setSearchLabel(query);
    }

    onSearch = () => {
        const { setActiveButtonSearch } = this.state;
        const { searchLabel, isHomePage, searchPage, selectType, categorySet, searchSiteName, showSitesFilter } = this.props;
        const { setIsLoading, setInitialData, setCategoriesData, setDropdownType, setCategory, setSelectedCategory, setSitename, setSitenameLabel } = this.props.actions;

        if (searchLabel.length <= 2){
            return;
        }

        if (setActiveButtonSearch) {
            this.setState({
                searchResults: []
            });
        }

        let locationHref = window.location.href;
        let isSearchPage = false;
        if (locationHref.includes('search/?search=')) {
            isSearchPage = true;
        };

        if (searchLabel && (isHomePage || !isSearchPage)) {
            this.setState({
                showSearchModal: true,
            });
        }

        const data = {
            query: searchLabel
        };
        if (isHomePage || !isSearchPage) {
            if (setActiveButtonSearch && searchLabel) {
                this.handleSearchText(data);
            }
            else {
                this.setState({ showSearchModal: true });
            }
        }
        else {
            let category = '';

            let selectedValue = {
                name: "All Results Type",
                type: ""
            };

            let data = {
                category: '',
                query: searchLabel,
                pageCount: 10,
                pageIndex: 1,
                type: '',
                siteName: searchSiteName && searchSiteName.length > 0 ? searchSiteName : ''
            }

            setIsLoading(true, false);
            let categoriesData = [];

            axios({
                method: 'post',
                url: '/api/azurecognitivesearch/',
                data: data,
            })
                .then((res) => {
                    let allData = { guid: "all", items: res.data.items, total: res.data.total, pageIndex: 1, promotedItems: res.data.promotedItems };
                    categoriesData.push(allData);
                    setTimeout(() => {
                        setDropdownType(selectedValue);
                        if (showSitesFilter) {
                            setSitename("");
                            setSitenameLabel("All Sites");
                        }
                        setSelectedCategory(allData);
                        setCategory('all');
                        setCategoriesData(categoriesData);
                        setInitialData(res.data);
                        setIsLoading(false, true);
                    }, 200);
                })
                .catch((err) => { throw err });
            let encodeSearchLabel = encodeURIComponent(searchLabel)
            let newUrl = searchPage.toLowerCase() + "/?search=" + encodeSearchLabel
            window.history.pushState(null, null, newUrl);
        }
        
        this.setState({ setActiveButtonSearch: false });
    }

    onSearchNoModal = (searchQuery = null) => {
        const { setActiveButtonSearch } = this.state;
        const { searchLabel, isHomePage, searchPage, selectType, categorySet, searchSiteName, showSitesFilter } = this.props;
        const { setIsLoading, setInitialData, setCategoriesData, setDropdownType, setCategory, setSelectedCategory, setNavigationDetails, setHidePromoted, setSitename, setSitenameLabel } = this.props.actions;

        if (searchLabel.length <= 2) {
            return;
        }

        if (setActiveButtonSearch) {
            this.setState({
                searchResults: []
            });
        }

        let locationHref = window.location.href;
        let isSearchPage = false;
        if (locationHref.includes('search/?search=')) {
            isSearchPage = true;
        };

        let searchQ = searchQuery ? searchQuery : searchLabel;
        if (isHomePage || !isSearchPage) {
            let encodeSearchLabel = encodeURIComponent(searchQ)
            let newUrl = searchPage.toLowerCase() + "/?search=" + encodeSearchLabel
            window.history.pushState(null, null, newUrl);
            window.location.reload();
        }
        else {
            let category = '';

            let selectedValue = {
                name: "All Results Type",
                type: ""
            };

            let data = {
                category: '',
                query: searchQ,
                pageCount: 10,
                pageIndex: 1,
                type: '',
                siteName: searchSiteName && searchSiteName.length > 0 ? searchSiteName : ''
            }

            setIsLoading(true, false);
            setHidePromoted(true);
            let categoriesData = [];
            
            this.setState({ setActiveButtonSearch: true });

            axios({
                method: 'post',
                url: '/api/azurecognitivesearch/',
                data: data,
            })
                .then((res) => {
                    let allData = { guid: "all", items: res.data.items, total: res.data.total, pageIndex: 1, promotedItems: res.data.promotedItems };
                    categoriesData.push(allData);

                    let numberOfPages = Math.ceil(res.data.total / data.pageCount);
                    let navigation = getNavigationDetails(1, numberOfPages);
                    setNavigationDetails(numberOfPages, 1, navigation);

                    setTimeout(() => {
                        setDropdownType(selectedValue);
                        if (showSitesFilter) {
                            setSitename("");
                            setSitenameLabel("All Sites");
                        }
                        setHidePromoted(false);
                        setSelectedCategory(allData);
                        setCategory('all');
                        setCategoriesData(categoriesData);
                        setInitialData(res.data);
                        setIsLoading(false, true);
                    }, 200);

                    setTimeout(() => {
                        if (window.pageYOffset > 20) {
                            window.scrollTo(0, 20);
                        }
                    }, 220);
                })
                .catch((err) => { throw err });

            if (searchQuery == null) {
                let encodeSearchLabel = encodeURIComponent(searchQ)
                let newUrl = searchPage.toLowerCase() + "/?search=" + encodeSearchLabel
                window.history.pushState(null, null, newUrl);
            }
        }
        this.setState({ setActiveButtonSearch: false });
    }


    onSearchText = (data) => {
        this.setState({ isLoading: true });
        axios({
            method: 'post',
            url: '/api/quicksearch/',
            data: data,
        })
            .then((res) => {
                this.setState({
                    searchResults: res.data,
                    isVisibleNoResult: true,
                    isLoading: false
                });
            })
            .catch((err) => { throw err });
    };

    closeSearchModal() {
        this.setState({ showSearchModal: false });
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter'
            && event.target.className.indexOf("react-autosuggest__input") !== -1) {
            this.onSearchNoModal();
        }
    }

    handleKeyPressNoSearch = (event) => {
        if (event.key === 'Enter'
            && event.target.className.indexOf("react-autosuggest__input") !== -1) {
            this.onSearchNoModal();
        }
    }

    render() {
        const { searchPage, searchLabel, isHomePage, labelId, searchSiteName, searchPlaceHolder } = this.props;
        const { searchResults, showSearchModal, isVisibleNoResult, isLoading, value } = this.state;
        let encodeSearchLabel = encodeURIComponent(searchLabel);
        let idSuggester = "search" + labelId;
        return (
            <React.Fragment>
                <div className="search-container" >
                    <div className="search-container-desktop">
                        <AutoSuggester
                            onSearch={this.onSearchNoModal}
                            quickSearchLoading={isLoading}
                            onChange={this.handleChange}
                            onKeyPress={this.handleKeyPressNoSearch}
                            searchLabel={searchLabel}
                            isHomePage={isHomePage}
                            idSuggester={idSuggester}
                            labelId={labelId}
                            siteName={searchSiteName}
                            searchPlaceHolder={searchPlaceHolder}
                        />
                    </div>
                </div>
                {false &&
                    <div ref={this.wrapperRef} className="wrapper" style={{ height: '0' }} >
                        {showSearchModal && !isLoading &&
                            <div className={"search-results" + ((showSearchModal && !isLoading) ? " show" : " hide")}>
                                <div className="container">
                                    {searchResults && searchResults.length > 0 &&
                                        <div className="row close" ><a className="close-menu" href="#" onClick={this.closeSearchModal.bind(this)}><i className="fa-solid fa-xmark"></i></a></div>
                                    }
                                    {searchResults && searchResults.length > 0 && searchResults.map((item, j) => {
                                        return (
                                            <SearchItemDetails
                                                item={item}
                                                j={j}
                                                getAllHighlights={getAllHighlights}
                                                key={j}
                                            />
                                        );
                                    })}
                                    {searchResults && searchResults.length > 0 &&
                                        <div className="row mt-3 all-result-link" ><a className="close-menu" href={searchPage + "?search=" + encodeSearchLabel}>
                                            View All Results
                                            <i className="fa-solid fa-angle-right"></i>
                                        </a></div>
                                    }
                                    {searchResults && searchResults.length == 0 && searchLabel.length > 2 && isVisibleNoResult &&
                                        <React.Fragment>
                                            <div className="row close" ><a className="close-menu" href="#" onClick={this.closeSearchModal.bind(this)}><i className="fa-solid fa-xmark"></i></a></div>
                                            <div className="no-results">
                                                No Results Found for "{searchLabel}". Try searching for something else.
                                            </div>
                                        </React.Fragment>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        searchLabel: state.searchResult.searchLabelStore ? state.searchResult.searchLabelStore : "",
        categoriesData: state.searchResult.categoriesData,
        selectType: state.searchResult.selectType,
        categorySet: state.searchResult.categorySet,
        selectedCategory: state.searchResult.selectedCategory,
        numberOfPages: (state.searchResult != null && state.searchResult.numberOfPages) ? state.searchResult.numberOfPages : 0,
        selectedPage: (state.searchResult != null && state.searchResult.selectedPage) ? state.searchResult.selectedPage : 1,
        navigation: (state.searchResult != null && state.searchResult.navigation) ? state.searchResult.navigation : null,
        showSitesFilter: state.searchResult.showSitesFilter
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            setSearchLabel: bindActionCreators(searchActions.setSearchLabel, dispatch),
            setIsLoading: bindActionCreators(searchActions.setIsLoading, dispatch),
            setInitialData: bindActionCreators(searchActions.setInitialData, dispatch),
            setCategoriesData: bindActionCreators(searchActions.setCategoriesData, dispatch),
            setDropdownType: bindActionCreators(searchActions.setDropdownType, dispatch),
            setCategory: bindActionCreators(searchActions.setCategory, dispatch),
            setSelectedCategory: bindActionCreators(searchActions.setSelectedCategory, dispatch),
            setNavigationDetails: bindActionCreators(searchActions.setNavigationDetails, dispatch),
            setHidePromoted: bindActionCreators(searchActions.setHidePromoted, dispatch),
            setSitename: bindActionCreators(searchActions.setSitename, dispatch),
            setSitenameLabel: bindActionCreators(searchActions.setSitenameLabel, dispatch),
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);